import React, { useRef, useState, useEffect } from 'react';
import { CSSTransition } from 'react-transition-group';
import * as Styled from './Table.styled';

const TRANSITION_DURATION = 200;

const Table = (props) => {
  const containerRef = useRef(null);
  const tableRef = useRef(null);
  const [cursorState, setCursorState] = useState(0);
  const [observerState, setObserverState] = useState(null);
  const shouldShowSwipeIcon =
    observerState?.boundingClientRect?.width > observerState?.rootBounds?.width;

  useEffect(() => {
    const element = tableRef.current;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          setObserverState(entry);
        });
      },
      { root: containerRef.current, threshold: 1 }
    );

    if (element) {
      observer.observe(element);
    }

    return () => {
      observer.unobserve(element);
    };
  }, []);

  useEffect(() => {
    if (shouldShowSwipeIcon && cursorState === 0) {
      setCursorState(1);
    }
  }, [observerState]);

  return (
    <Styled.Wrapper ref={containerRef}>
      <Styled.Table
        ref={tableRef}
        onTouchStart={() => setCursorState(2)}
        onWheel={() => setCursorState(2)}
        {...props}
      />
      {shouldShowSwipeIcon && (
        <CSSTransition
          appear
          in={cursorState === 1}
          classNames="fade"
          timeout={TRANSITION_DURATION}
          unmountOnExit
        >
          <Styled.SwipeIcon
            containerHeight={observerState.rootBounds.height}
            containerWidth={observerState.rootBounds.width}
            transitionDuration={TRANSITION_DURATION}
          />
        </CSSTransition>
      )}
    </Styled.Wrapper>
  );
};

export { Table, Table as default };
export {
  TableContainer,
  TableHead,
  TableBody,
  TableHeader,
  TableRow,
  TableCell
} from './Table.styled';
